import R from 'ramda';
import { createReducer } from 'ha/myredux/createReducer';
import { Actions } from '../constants';

export const initialState = {
  apartment: {},
  room: {},
};

export default createReducer(
  {
    [Actions.LOAD_DONE]: (state, { searchCategories }) => ({
      ...state,
      ...searchCategories,
    }),
  },
  initialState,
);

export const getLocalizedApartmentSlug = R.path(['apartment', 'localizedSlug']);
export const getLocalizedRoomSlug = R.path(['room', 'localizedSlug']);
